import { Controller } from "@hotwired/stimulus"

// The dashboard's Net worth card (budgets/_net_worth_budget_card). Tapping
// the Have or Owe tube rolls the copy to that side: its total and at most two
// key lines, rendered by the server in each language (budgets/
// _net_worth_card_copy, one <template> per state). The tapped liquid wobbles,
// the other tube dims. Tapping the same tube again, or HOLD_MS later, rolls
// back to Net worth.
//
// The carousel swallows the click that trails a swipe (budget_carousel_
// controller#_click), so a swipe across the tubes never counts as a tap.
const HOLD_MS = 4000

export default class extends Controller {
  static targets = ["copy", "state", "tube", "liquid"]

  connect() {
    this.current = "home"
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  pick(event) {
    const state = event.params.state
    const tube = event.currentTarget
    this.wobble(tube)
    clearTimeout(this.timer)

    if (state === this.current) {
      this.show("home")
      return
    }
    this.show(state)
    this.timer = setTimeout(() => this.show("home"), HOLD_MS)
  }

  show(state) {
    const template = this.stateTargets.find((el) => el.dataset.state === state)
    if (!template) return

    this.current = state
    // Fresh nodes: the copy's nw-card-in entrance plays again, the roll.
    this.copyTarget.replaceChildren(template.content.cloneNode(true))
    this.tubeTargets.forEach((tube) => {
      const side = tube.dataset.netWorthCardStateParam
      tube.classList.toggle("is-on", side === state)
      tube.setAttribute("aria-pressed", side === state)
      tube.classList.toggle("is-dim", state !== "home" && side !== state)
    })
  }

  // Restart the wobble even mid-way through the last one.
  wobble(tube) {
    const liquid = this.liquidTargets.find((el) => tube.contains(el))
    if (!liquid) return

    liquid.classList.remove("is-wobble")
    void liquid.offsetWidth
    liquid.classList.add("is-wobble")
  }
}
